import { Divider, Form } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCarrierSearchProgress, getCarrierSearchReset } from '../../../../redux/common/CommonActions';
import { routeFileSelector } from '../../../../utilz/i18n';
import Button from '../../../components/Buttons/Button';
import EmptyRecords from '../../../components/Common/EmptyRecords';
import SecondaryLabel from '../../../components/Labels/SecondaryLabel';
import CommonModal from '../../../components/Modals/CommonModal';
import ScrollPagination from '../../../components/Paginations/ScrollPagination';
import CarrierSearchCard from './CarrierSearchCard';
import CarrierSearchForm from './CarrierSearchForm';

const CarrierSearchModal = ({ open, handleSelect = () => {}, handleClose, labelForTestId }) => {
  const dispatch = useDispatch();
  const [isFiltered, setIsFiltered] = useState(false);
  const [form] = Form.useForm();
  const { carrierSearch } = useSelector((state) => state.common);
  const onSubmit = () => {
    setIsFiltered(true);
  };
  const handleReset = () => {
    setIsFiltered(false);
    dispatch(getCarrierSearchReset());
    form.resetFields();
  };

  const handleCloseLocal = () => {
    handleReset();
    handleClose();
  };

  const handleNextPage = () => {
    const payload = {
      ...carrierSearch.requestData,
      PageIndex: carrierSearch.requestData.PageIndex + 1,
    };
    dispatch(getCarrierSearchProgress(payload));
  };

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <CommonModal
      title={t('translation:default.fields.transportationProviderSearch')}
      open={open}
      className={`${isFiltered ? 'vh-85' : 'h-auto'} vw-70`}
      customFooter={
        isFiltered && !carrierSearch?.error ? (
          <div className="pr-15 pb-15">
            <Button
              id="cancelButtonId"
              variant="danger"
              type="default"
              onClick={handleCloseLocal}
              className="float-right"
            >
              {t('translation:default.buttons.cancel')}
            </Button>
          </div>
        ) : (
          <></>
        )
      }
      descriptionClassName="mb-5 d-flex flex-direction-column"
      contentClassName="p-0"
      onCancel={handleCloseLocal}
      onClose={handleCloseLocal}
      labelForTestId={labelForTestId ? `${labelForTestId}-transportation-modal` : ''}
    >
      <div className="py-15 d-flex flex-direction-column flex-1 overflow-hidden">
        <div className="px-15">
          <CarrierSearchForm
            formInstance={form}
            onSubmit={onSubmit}
            labelForTestId={labelForTestId}
            modalTypeForTest="transportation-modal"
          />
        </div>

        {isFiltered && <Divider className="my-15 border-top-border" />}

        {carrierSearch?.error ? (
          <SecondaryLabel className="text-danger fw-600 f-18 text-center">{carrierSearch?.message}</SecondaryLabel>
        ) : (
          <div className="flex-1 overflow-hidden">
            {isFiltered && (
              <>
                <div className="h-100 overflow-hidden ">
                  <div className="py-15 h-100 overflow-hidden">
                    <div className=" h-100 overflow-hidden">
                      <ScrollPagination
                        className="h-100 px-15"
                        loadMore={handleNextPage}
                        isLoading={carrierSearch?.progressing}
                        hasMore={
                          carrierSearch?.progressing
                            ? false
                            : carrierSearch?.requestData.PageIndex <
                              Math.ceil(carrierSearch?.totalRecords / carrierSearch?.requestData.PageSize)
                        }
                        scrollOffset={50}
                      >
                        {carrierSearch?.data?.length > 0 ? (
                          <>
                            {carrierSearch?.data.map((row, index) => (
                              <CarrierSearchCard
                                // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                                key={index}
                                data={row}
                                handleSelect={(data) => {
                                  handleSelect(data);
                                  handleReset();
                                }}
                                labelForTestId={labelForTestId}
                              />
                            ))}
                          </>
                        ) : (
                          !carrierSearch?.progressing &&
                          (carrierSearch?.success || carrierSearch?.error) && <EmptyRecords />
                        )}
                      </ScrollPagination>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </CommonModal>
  );
};

export default CarrierSearchModal;
